import type { FaireProductEntity } from "../../entity_types/product";

export const p_3hcsxm54zn: FaireProductEntity = {
  token: "p_3hcsxm54zn",
  type: "product",
  name: "Capiz Rectangular Box w/Bird Design",
  brandName: "Dekorasyon Gifts  Decor",
  imageUrl:
    "https://cdn.faire.com/fastly/c42d92c0093e2fdfaf4f0d5cac92ed1e261b8222c2bed32b88d53ea637f24d12.jpeg",
  priceDollars: 6.6,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/9466f061488942811731da243ab5275c8f0d28a406fe402c3586abe0960741b6.png",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
